import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { getUserType, USER_TYPES } from "../../config/roles";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  function handleGoHome() {
    const type = getUserType(user);
    if (!user) return navigate("/login", { replace: true });
    if (type === USER_TYPES.ADMIN) return navigate("/admin", { replace: true });
    if (type === USER_TYPES.CEED) return navigate("/ceed", { replace: true });
    navigate("/dashboard", { replace: true });
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        fontFamily: "'DM Sans', sans-serif",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontSize: "96px",
          fontFamily: "'DM Sans', sans-serif",
          color: "#f9ab14",
          lineHeight: 1,
          marginBottom: "8px",
        }}
      >
        404
      </div>

      <h1
        style={{
          fontSize: "22px",
          fontWeight: 700,
          color: "#111827",
          margin: "0 0 10px",
        }}
      >
        Page not found
      </h1>

      <p
        style={{
          fontSize: "14px",
          color: "#6b7280",
          maxWidth: "360px",
          lineHeight: 1.6,
          marginBottom: "32px",
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </p>

      <button
        onClick={handleGoHome}
        style={{
          background: "#f9ab14",
          color: "#060a0e",
          border: "none",
          borderRadius: "10px",
          padding: "11px 28px",
          fontSize: "14px",
          fontWeight: 600,
          cursor: "pointer",
          transition: "background 0.15s",
        }}
        onMouseEnter={e => (e.currentTarget.style.background = "#e59400")}
        onMouseLeave={e => (e.currentTarget.style.background = "#f9ab14")}
      >
        Go to Dashboard
      </button>
    </div>
  );
}
